module.exports = __webpack_public_path__ + "img/native-background.64dc5167.jpg";